import { onError } from '@apollo/client/link/error';
import { LocalStorage } from 'libs/storage/LocalStorage';
const PUBLIC_PATH_PREFIXES = [
    '/form',
    '/store',
    '/interactive-quote',
    '/public',
    '/pipedrive',
    '/orders',
    '/vouchers',
    '/signup',
    '/documentation'
];
function isPublicPath(pathname) {
    return PUBLIC_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
/**
 * Manages graphql errors.
 * @const errorLink,
 * @since 1.0.0
 */
export const errorLink = onError((error) => {
    const { graphQLErrors, networkError } = error;
    if (networkError) {
        console.error(networkError);
    }
    if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => console.error(`[GraphQL error]: ${message}, Location: ${locations}, Path: ${path}`));
        for (const error of graphQLErrors) {
            if (error.extensions) {
                if (error.extensions.code == 'AUTHORIZATION_ERROR') {
                    location.href = '/unauthorized';
                }
                /*
                 * The authorization token is either malformed, not active or
                 * not existant.
                 */
                if (error.extensions.code == 'AUTHORIZATION_TOKEN_ERROR') {
                    if (isPublicPath(location.pathname)) {
                        return;
                    }
                    LocalStorage.set('session.token', null);
                    LocalStorage.get('session.startedAt', null);
                    LocalStorage.get('session.expiresAt', null);
                    const path = location.pathname;
                    location.href = '/authenticate' + '?redirect=' + path;
                    return;
                }
                console.error(error);
            }
        }
    }
});
